export default __webpack_public_path__ + "static/reactjs-4022c4d76c7787bfe1ab70dc912a0205.svg";